export default __webpack_public_path__ + "static/media/BC_294_BC_R9491.7953f82f.jpg";